// extracted by mini-css-extract-plugin
export default {"paragraphCard":"ParagraphBox_paragraphCard__V1Eoe","paragraphHeader":"ParagraphBox_paragraphHeader__Au5H6","h3":"ParagraphBox_h3__F-lvk","img":"ParagraphBox_img__TsZO5"};